/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string, func, number } from 'prop-types';
import { Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = (width, height) => makeStyles((theme) => ({
    avatarContainer: {
        position: 'relative',
        width,
        height,
        border: '1px solid #D5D5D5',
        padding: '5px',
        borderRadius: '50%',
    },
    avatar: {
        width: '100%',
        height: '100%',
        cursor: 'pointer',
    },
    editIcon: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: '#FFFFFF', // Customize the background color to be brand specific?
        color: '#000000', // Customize the icon color to be brand specific?
        borderRadius: '50%',
        padding: theme.spacing(2),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#FFFFFF',
        },
    },
}));

const RecipientAvatar = ({ onClick, width, height, recipientFirstInitial, recipientLastInitial }) => {
    const classesLayout = useStyles(width, height);
    const classes = classesLayout(width, height);

    const handleAvatarClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (
        <div className={classes.avatarContainer}>
            <Avatar className={classes.avatar}
                onClick={() => handleAvatarClick()}>{`${recipientFirstInitial?.toUpperCase()}${recipientLastInitial?.toUpperCase()}`}
            </Avatar>
        </div>
    );
};

RecipientAvatar.propTypes = {
    onClick: func,
    width: number.isRequired,
    height: number.isRequired,
    recipientFirstInitial: string.isRequired,
    recipientLastInitial: string.isRequired,
};

RecipientAvatar.defaultProps = {
    onClick: () => { },
};

export default RecipientAvatar;
